import React, { useState, useEffect } from "react";
import { Video, Link as LinkIcon, X, Plus } from "lucide-react";

export default function AdminPerformances() {
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [data, setData] = useState([]);
  const [collection, setCollection] = useState([]);

  const [showCollectionFor, setShowCollectionFor] = useState(null);

  const [formData, setFormData] = useState({
    title: "",
    desc: "",
    image: "",
    link: ""
  });

  useEffect(() => {
    fetchPerformances();
  }, []);

  useEffect(() => {
    if (showForm) {
      fetchCollection();
    }
  }, [showForm]);

  const fetchPerformances = async () => {
    const res = await fetch("/api/admin/medias/performances.php");
    const performances = await res.json();
    setData(performances);
  };

  const fetchCollection = async () => {
    const res = await fetch("/api/admin/assets/collection.php");
    const collection = await res.json();
    setCollection(collection);
  };

  async function handleSubmit(e) {
  e.preventDefault();

  const url = editingId
    ? "/api/admin/medias/edit_performance.php"
    : "/api/admin/medias/add_performance.php";

  const form = new FormData();
  form.append("title", formData.title);
  form.append("desc", formData.desc);
  form.append("link", formData.link || "");

    ["image"].forEach(field => {
    if (formData[field] instanceof File) {
      form.append(field, formData[field]);
    } else if (typeof formData[field] === "string" && formData[field]) {
      form.append(field, formData[field]);
    }
  });

  if (editingId) {
    form.append("id", editingId);
  }

  try {
    const res = await fetch(url, {
      method: "POST",
      body: form
    });

    if (!res.ok) throw new Error("Erreur sauvegarde");

    fetchPerformances();
    resetForm();
  } catch (err) {
    console.error(err);
    alert("Erreur upload");
  }
}

  function resetForm() {
    setShowForm(false);
    setEditingId(null);
    setFormData({
                                title: "",
                                desc: "",
                                image: "",
                                link: ""
    });
  }

  function editPerformance(performance) {
    setFormData({
      title: performance.title,
      desc: performance.desc,
      image: performance.image,
      link: performance.link
    });

    setEditingId(performance.id);
    setShowForm(true);
  }

  async function deletePerformance(id) {
    if (!window.confirm("Supprimer cette video ?")) return;

    try {
      await fetch("/api/admin/medias/delete_performance.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id })
      });

      fetchPerformances();
    } catch (err) {
      console.error("Erreur suppression video", err);
    }
  }

  async function movePerformance(id, direction) {
  await fetch("/api/admin/medias/move_performance.php", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id, direction })
  });

  fetchPerformances();
}
    const getYoutubeEmbed = (url) => {
    if (!url) return null;

    const regExp =
        /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/;
    const match = url.match(regExp);

    return match ? `https://www.youtube.com/embed/${match[1]}` : null;
    };

  return (
      <section>
      <div>
                <div className="container-xl">
                  <div className="bg-white rounded shadow p-4">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h1 className="cat-title h3 fw-bold text-dark d-flex align-items-center gap-2">
                          <Video className="text-primary" />
                          Performances
                        </h1>
                        <p className="text-secondary mb-0">
                          Ajouter, modifier ou supprimer des videos
                        </p>
                        <button
                          onClick={() => {
                            setShowForm(!showForm);
                            if (showForm) {
                              setEditingId(null);
                              setFormData({
                                title: "",
                                desc: "",
                                image: "",
                                link: ""
                              });
                            }
                          }}
                          className="btn btn-primary d-flex align-items-center gap-2 mt-2"
                        >
                          <Plus size={20} />
                          Ajouter
                        </button>
                      </div>
                    </div>
                  {showForm && (
                    <div className="bg-primary bg-opacity-10 p-4 rounded mt-4 w-100">
                      <h3 className="fw-semibold mb-3">
                        {editingId ? "Modifier la video" : "Nouvelle Video"}
                      </h3>
      
                      <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor='title'>Titre</label>
                                <input className="form-control" type='text' value={formData.title} name='title' required onChange={(e)=> setFormData({...formData, title: e.target.value})}>
                                </input>
                              </div>
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor='desc'>Description</label>
                                <input className="form-control" type='text' value={formData.desc} name='desc' required onChange={(e)=> setFormData({...formData, desc: e.target.value})}>
                                </input>
                              </div>
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor='link'>Lien</label>
                                <input className="form-control" type='text' value={formData.link} name='link' onChange={(e)=> setFormData({...formData, link: e.target.value})}>
                                </input>
                              </div>
                            </div>
                            <div className="col-12 mt-4">
                                <label className="form-label fw-medium" htmlFor='img'>Image Box</label>
                                <input
                                  className="form-control"
                                  type="file"
                                  accept="image/*"
                                  name="image"
                                  onChange={(e)=> setFormData({...formData, image: e.target.files[0]})}
                                />
                                <button
                                  type="button"
                                  className="btn
                                   btn-sm col-2 btn-outline-primary mt-2"
                                  onClick={() => setShowCollectionFor("image")}
                                >
                                  Collection
                                </button>

                                {/* Image existante */}
                                <div>
                                {typeof formData.image === "string" && formData.image && (
                                  <img
                                    src={formData.image}
                                    alt="preview"
                                    style={{ width: "200px", marginTop: "10px" }}
                                  />
                                )}

                                {/* Nouvelle image */}
                                {formData.image instanceof File && (
                                  <img
                                    src={URL.createObjectURL(formData.image)}
                                    alt="preview"
                                    style={{ width: "200px", marginTop: "10px" }}
                                  />
                                )}
                                </div>
                              </div>
                            <div className="d-flex gap-2 mt-4">
                              <button type="submit" className="btn btn-primary">
                                {editingId ? "Modifier" : "Enregistrer"}
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setShowForm(false);
                                  setEditingId(null);
                                  setFormData({
                                    title: "",
                                    desc: "",
                                    image: "",
                                    link: ""
                                  });
                                  setShowCollectionFor(null);
                                }}
                                className="btn btn-secondary"
                              >
                                Annuler
                              </button>
                            </div>
                          </form>
                        </div>
                      )}
                      {showCollectionFor && (
                        <div className="mt-4 p-3 border rounded bg-light">
                          <h5>Sélectionner une image</h5>

                          <div className="row">
                            {collection.map((img) => (
                              <div className="col-3 mb-3" key={img.id}>
                                <img
                                  src={img.image}
                                  alt=""
                                  style={{ width: "100%", cursor: "pointer" }}
                                  onClick={() => {
                                    setFormData({
                                      ...formData,
                                      [showCollectionFor]: img.image
                                    });
                                    setShowCollectionFor(null);
                                  }}
                                />
                              </div>
                            ))}
                          </div>

                          <button
                            type="button"
                            className="btn btn-secondary btn-sm mt-2"
                            onClick={() => setShowCollectionFor(null)}
                          >
                            Fermer
                          </button>
                        </div>
                      )}
                      <div className="row g-3 pt-4">
                        {data.map((performance, i) => {
      
                          return (
                            <div className="col-md-4 mb-3" key={performance.id}>
                              <div className="card border-dark bg-white rounded shadow p-3 h-100">
                                <div className="border-bottom pb-2 mb-2">
                                  <h2 className="h4 fw-bold">{performance.title}</h2>
                                  <p className="text-muted small mb-1">{performance.desc}</p>
                                  <img
                                    src={performance.image}
                                    alt="preview"
                                    style={{ width: "100%", marginTop: "10px" }}
                                  />
                                  <p className="text-muted small mb-1 mt-2">{performance.link}</p>
                                </div>

                                          <div className="d-flex gap-1">
                                            <button
                                              onClick={() => editPerformance(performance)}
                                              className="btn btn-sm btn-outline-dark"
                                              title="Modifier"
                                            >
                                              Modifier
                                            </button>
                                            <button
                                              onClick={() => deletePerformance(performance.id)}
                                              className="btn btn-sm btn-outline-dark"
                                              title="Supprimer"
                                            >
                                              <X size={18} />
                                            </button>
                                            <button
                                              onClick={() => movePerformance(performance.id, "up")}
                                              className="btn btn-sm btn-outline-dark"
                                            >
                                              ↑
                                            </button>

                                            <button
                                              onClick={() => movePerformance(performance.id, "down")}
                                              className="btn btn-sm btn-outline-dark"
                                            >
                                              ↓
                                            </button>
                                          </div>
                                  </div>
                            </div>
                          );
                        })}
                      </div>
                  </div>
                </div>
              </div>
    </section>
  );
}